function PlpNativeSkeletonHeader() {
  return (
    <>
      <div className="px-5 py-3 border-r border-neutral-900 lg:px-10 animate-pulse">
        <div className="h-5 w-[64px] animate-pulse bg-skeleton" />
      </div>
      <div className="flex-1 animate-pulse">
        <div className="h-5 w-16 bg-skeleton mx-auto" />
      </div>
      <div className="px-5 py-3 border-l border-neutral-900 lg:px-10 animate-pulse">
        <div className="h-5 w-[45px] animate-pulse bg-skeleton" />
      </div>
    </>
  )
}

export default PlpNativeSkeletonHeader
